
import MergeOptionHandler from "~/fc/AdvacedSettings/MergeOptionHandler";
import { MERGE_OPTION_IDS } from "~/config/config";
const mergeOptionId = MERGE_OPTION_IDS;

export default {
  components: {
    ToolTip: () => import(/* webpackChunkName: "ToolTip" */ "../../ToolTip"),
  },
  props: ["value", "field", "selection", "isDisabled"],
  computed: {
    advancedOptionListResponsiveView() {
      return this.$store.state.store.advancedOptionListResponsiveView;
    },
    fullLayout() {
      return (
        this.field.customVariables &&
        this.field.customVariables.layout === "full"
      );
    },
    isMergeCheckbox() {
      return mergeOptionId.includes(this.field.id);
    },
  },
  methods: {
    onChange() {
      this.$emit("input", !this.value);
      if (this.isMergeCheckbox) {
        new MergeOptionHandler().setMerge(!this.value);
      }
    },
  },
};
